import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardFn } from '@dta/ui/guards/auth.guard';
import { provideTrialNotice } from '@shared/services/trial-notice/trial-notice.provider';
import { provideDraftConversationChanges } from '@shared/modules/conversations/services/draft-conversation-changes/draft-conversation-changes.provider';
import { deeplinkRoute } from '@shared/modules/deeplinks/common/constants/deeplink-route';
import { environment } from '../environments/environment';

export const uiPlaygroundRoute = 'ui-playground';

// Dev-only route: lets developers visually test/tweak alert, toast and notification card styling.
// Not linked from the app UI and excluded from production builds.
const uiPlaygroundRoutes: Routes = environment.isProduction
  ? []
  : [
      {
        path: uiPlaygroundRoute,
        loadComponent: () =>
          import('./components/ui-playground/ui-playground.component').then(m => m.UiPlaygroundComponent)
      }
    ];

export const WEB_ROUTES: Routes = [
  {
    path: deeplinkRoute,
    loadChildren: () => import('./components/deeplink/deeplink.module').then(m => m.DeeplinkModule)
  },
  ...uiPlaygroundRoutes,
  {
    path: 'login',
    loadChildren: () => import('../../shared/modules/login/login.module').then(m => m.LoginModule)
  },
  {
    path: '',
    loadChildren: () => import('../../shared/modules/main/main.module').then(m => m.MainModule),
    canActivate: [AuthGuardFn],
    providers: [provideTrialNotice(), provideDraftConversationChanges()]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(WEB_ROUTES, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class WebRoutingModule {}
